import React from "react";
import styles from "./content.module.scss";
import { Route, Switch } from "react-router";
import CarsBar from "../sections/sideBars/carsBar";
import { CarsMap, CarData, CarInfoData } from "../sections/contentBlocks/contentBlocksContainer";

const CarsContent = (props) => {
  return (
    <div className={props.isSideBarOpen ? styles.content : styles.content_closedBar}>
      <Switch>
        <Route exact path={["/", "/cars", "/cars-info", "/cars/:id", "/cars/:id/intimerange", "/cars/:id/inmoment", "/cars/:id/settings"]}>
          <div className={styles.container_sideBar}>
            <CarsBar />
          </div>

          <div className={styles.container_sideContent}>
            <Switch>
              <Route exact path={["/", "/cars", "/drivers", "/devices"]} component={CarsMap} />
              <Route exact path={["/cars/:id", "/cars/:id/intimerange", "/cars/:id/inmoment"]} component={CarData} />
              <Route exact path="/cars/:id/settings" component={CarInfoData} />
            </Switch>
          </div>
        </Route>
      </Switch>
    </div>
  );
};

export default React.memo(CarsContent);
